import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { UserContext } from "../context/UserContext";

export default function ProtectedRoute() {
  const { user, loading } = useContext(UserContext);
  const location = useLocation();

  // Wait until UserContext finishes checking /users/me
  if (loading) {
    return <div>Loading...</div>;
  }

  // If no logged-in user, redirect to login
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // User is logged in, allow access to child routes
  return <Outlet />;
}
